import { gql } from "@apollo/client";

export const donorEntryQuery = gql`
  query DonorEntryQuery($id: SweepstakesSlug!, $page: Int!, $pageSize: Int!) {
    donorGuestEntries(id: $id, page: $page, pageSize: $pageSize) {
      page
      pageSize
      totalCount
      items {
        id
        createdAt
        status
        formattedAmount
        firstName
        lastName
        email
        promoCode {
          id
          name
        }
        ticketRanges {
          min
          max
        }
      }
    }
  }
`;

export const sweepstakesQuery = gql`
  query DonorEntrySweepstakesQuery($id: SweepstakesSlug!) {
    sweepstakes(id: $id) {
      id
      headline
      nonprofit {
        id
        profile {
          id
          email
        }
      }
    }
  }
`;

export const createGuestSessionMutation = gql`
  mutation CreateGuestSessionMutation($sweepstakesId: SweepstakesSlug!, $email: String!, $captcha: String!) {
    createGuestSession(sweepstakesId: $sweepstakesId, email: $email, captcha: $captcha) {
      error {
        message
      }
    }
  }
`;

export const loginToGuestSessionMutation = gql`
  mutation LoginToGuestSessionMutation($otp: String!) {
    loginToGuestSession(otp: $otp) {
      guestSession {
        authToken
      }
      error {
        message
      }
    }
  }
`;

export const headerQuery = gql`
  query SubheaderQuery($id: SweepstakesSlug!) {
    sweepstakes(id: $id) {
      id
      nonprofit {
        id
        name

        profile {
          id
          cause
          color

          logo {
            publicId
            version
            cloudName
          }
        }
      }
    }
  }
`
